import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { ToastProps } from "./Toast.props";
import SvgIcon from "../SvgIcon/SvgIcon";
import { CheckIcon, WarningIcon, XIcon } from "@assets/icons"; // ✅ add InfoIcon
import P from "../P/P";

const statusStyles = {
	success:
		"bg-light-mainColor dark:bg-dark-mainColor text-light-bgColor dark:text-dark-bgColor",
	error:
		"bg-light-red dark:bg-dark-red text-light-whiteText dark:text-dark-whiteText",
	warn: "bg-light-warning dark:bg-dark-warning text-light-whiteText dark:text-dark-whiteText",

	// ✅ NEW
	info: "bg-light-shadeTwo dark:bg-dark-shadeTwo text-light-white dark:text-dark-white",
};

const Toast: React.FC<ToastProps & { onClose: () => void }> = ({
	message,
	status,
	onClose,
	duration = 5000,
	autoClose = true,
}) => {
	useEffect(() => {
		if (autoClose) {
			const timer = setTimeout(onClose, duration);
			return () => clearTimeout(timer);
		}
		return undefined;
	}, [autoClose, duration, onClose]);

	return (
		<motion.div
			initial={{ opacity: 0, y: -20 }}
			animate={{ opacity: 1, y: 0 }}
			exit={{ opacity: 0, y: 20 }}
			className={`grid grid-cols-maxThree gap-3 p-5 rounded-xl place-items-center ${statusStyles[status]}`}
		>
			<div className="p-1 rounded-md bg-light-lowWhite dark:bg-dark-lowWhite">
				<SvgIcon
					Icon={
						status === "success"
							? CheckIcon
							: status === "info"
								? WarningIcon // ✅ NEW
								: WarningIcon
					}
					className="w-4 h-4"
				/>
			</div>

			<P size="p3" type="semibold">
				{message}
			</P>

			<button onClick={onClose}>
				<SvgIcon
					Icon={XIcon}
					className="w-4 h-4 stroke-light-bgColor dark:stroke-dark-bgColor"
				/>
			</button>
		</motion.div>
	);
};

export default Toast;
